module.exports = __webpack_public_path__ + "img/even-numbered-pages.0822a10.svg";